import { useMemo, useState } from 'react';

export const WordCharacterCounter = () => {
    const [inputValue, setInputValue] = useState('');

    const { wordCount, characterCount } = useMemo(() => {
        const trimmedValue = inputValue.trim();
        const words = trimmedValue ? trimmedValue.split(/\s+/).length : 0;

        return {
            wordCount: words,
            characterCount: inputValue.length,
        };
    }, [inputValue]);

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setInputValue(event.target.value);
    };

    return (
        <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-2">Word & Character Counter</h2>
            <textarea
                className="w-full min-h-[180px] rounded-md border border-gray-300 p-3 text-sm text-gray-900 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
                placeholder="Paste your text here..."
                value={inputValue}
                onChange={handleChange}
            />
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="rounded-md border border-gray-200 bg-gray-50 p-4">
                    <p className="text-xs uppercase tracking-wide text-gray-500">Words</p>
                    <p className="text-2xl font-semibold text-gray-900">{wordCount}</p>
                </div>
                <div className="rounded-md border border-gray-200 bg-gray-50 p-4">
                    <p className="text-xs uppercase tracking-wide text-gray-500">Characters</p>
                    <p className="text-2xl font-semibold text-gray-900">{characterCount}</p>
                </div>
            </div>
        </div>
    );
};
